const createAction = <T extends string | number, P>(type: T, payload: P) => {
  return { type, payload } as const;
};

export { createAction };
